import React from "react";
import styles from './FormikDateSelector.module.scss';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import {getDatePlusDays, getDatePlusYears, zeroTime} from 'data/utils/calculators';
import FormErrorDisplay from 'gui/components/formErrorDisplay';

export interface IFormikDateSelectorProps {
  label: string;
  options: string[];
  rtl: boolean;
  field?: any;
  form?: any;
  minDate?: Date;
  maxDate?: Date;
  format?: string;
  onChange?: any;
  onClose?: any
  handleChange?: any;

  noBorder?: boolean;
}

const FormikDateSelector = (props: IFormikDateSelectorProps) => {
  const touched = props.form.touched[props.field.name];
  const error = touched && props.form.errors[props.field.name];
  const valid = touched && !error;
  return (
    <>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={"en"}>
        <DatePicker
          id={props.field.name}
          name={props.field.name}
          autoOk
          fullWidth={true}
          variant="inline"
          inputVariant="outlined"
          label={props.label}
          value={props.field.value && new Date(props.field.value)}
          format="MMM D YYYY"
          onChange={(value) => {
            props.field.onChange({
              target: {
                name: props.field.name,
                value: zeroTime(value.toDate()).getTime(),
              },
            });
            if (props.handleChange)
              props.handleChange(value.toDate().getTime());
          }}
          onBlur={props.field.onBlur}
          className={`${styles.TextField} ${(error ? `${styles.error} ` : "")} ${(valid ? `${styles.valid}` : "")} ${props.noBorder ? styles.noBorder : ''}`.trim()}
          minDate={props.minDate}
          maxDate={props.maxDate}
          invalidLabel={null}
          invalidDateMessage={null}
          minDateMessage=' '

        />
      </MuiPickersUtilsProvider>
      <FormErrorDisplay className={styles.displayError} error={error}/>
    </>
  );
};

FormikDateSelector.defaultProps = {
  minDate: getDatePlusDays(1),
  maxDate: getDatePlusYears(10),
  options: [],
  rtl: true,
  noBorder: false,
};

export default FormikDateSelector;
